import {capitalize as muiCapitalize} from '@material-ui/core';

const capitalize = (string) => {
    if (!string)
        return '';

    return muiCapitalize(string.toLowerCase()).trim();
};

export default capitalize;